import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/reports';

  getKnittingOrderReport(knittingOrderId: string): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/knittingorder/${knittingOrderId}`, { responseType: 'blob' });
  }

  getProductionCardReport(productionCardId: string): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/production-card/${productionCardId}`, { responseType: 'blob' });
  }

  getProductionCardBalanceReport(productionCardId: string): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/production-card/${productionCardId}/balance`, { responseType: 'blob' });
  }

  getChemicalConsumptionReport(year: number, month: number, offsetMinutes: number, includeAllConsumptions = false): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/chemical-consumption/excel`, {
      params: { year, month, offsetMinutes, includeAllConsumptions },
      responseType: 'blob',
    });
  }

  getMachineAssignmentReport(year: number, month: number, offsetMinutes: number): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/machine-assignment/excel`, {
      params: { year, month, offsetMinutes },
      responseType: 'blob',
    });
  }

  /** An empty `processes` means every process. */
  getDailyProductionReport(fromDate: string, toDate: string, offsetMinutes: number, processes: string[] = []): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/daily-production/excel`, {
      params: { fromDate, toDate, offsetMinutes, processes },
      responseType: 'blob',
    });
  }

  /** An empty `processes` means every process. */
  getProductionDetailReport(fromDate: string, toDate: string, offsetMinutes: number, processes: string[] = []): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/production-detail/excel`, {
      params: { fromDate, toDate, offsetMinutes, processes },
      responseType: 'blob',
    });
  }

  getTransferReport(entityId: string, entityType: string, transferType: string): Observable<Blob> {
    const params = {
      entityType: entityType,
      transferType: transferType,
    };
    return this.httpClient.get(`${environment.proxyUrls.inventoryApi}/api/v1/report/production-transfer/${entityId}`, {
      params,
      responseType: 'blob',
    });
  }
}
